import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-file-preview',
    templateUrl: 'file-preview.component.html',
    standalone: true
})
export class FilePreviewComponent implements OnInit {
    pdfUrl: SafeResourceUrl | null = null;

    /** Same URL as string — for “open in new tab” when iframe preview is blocked or downloads. */
    rawUrl = '';

    constructor(
        public config: DynamicDialogConfig,
        private messageService: MessageService,
        private sanitizer: DomSanitizer
    ) {}

    ngOnInit(): void {
        const url = this.config.data?.url;
        if (!url || typeof url !== 'string') {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: "Document can't be opened to preview."
            });
            return;
        }
        this.rawUrl = url;
        // Fragment hints Chrome’s PDF plugin to render in-frame when cross-origin allows it.
        const withViewerHint = url.includes('#') ? url : `${url}#view=FitH`;
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(withViewerHint);
    }
}
